module.exports = __webpack_public_path__ + "static/media/logo_namabank.95aaddff.svg";